/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum InvitationUrlsStatus {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  EXPIRED = "EXPIRED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CreateInvitationUrlQuery
// ====================================================

export interface CreateInvitationUrlQuery_invitationUrls_urls {
  id: string;
  url: string;
  status: InvitationUrlsStatus;
}

export interface CreateInvitationUrlQuery_invitationUrls {
  urls: (CreateInvitationUrlQuery_invitationUrls_urls | null)[];
}

export interface CreateInvitationUrlQuery {
  invitationUrls: CreateInvitationUrlQuery_invitationUrls;
}
